import { format, isValid, getYear } from "date-fns";

export const getAge = (dob: string | number | Date) => {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
};

export const getFormattedDate = (value: string | number | Date) => {
    let formattedDate = "";
    if (value) {
        const dateValue = new Date(value);
        if (isValid(dateValue)) {
            formattedDate = format(dateValue, "MM/dd/yyyy");
        }
        return getYear(dateValue) !== 1 ? formattedDate : "";
    }
    return formattedDate;
};

export const getFormattedDateTime = (value: string | number | Date) => {
    let formattedDate = "";
    if (value) {
        const dateValue = new Date(value);
        if (isValid(dateValue)) {
            formattedDate = format(dateValue, "MM/dd/yyyy hh:mm a");
        }
        return getYear(dateValue) !== 1 ? formattedDate : "";
    }
    return formattedDate;
};
